import * as yup from 'yup';
import { CheckboxTextSchema, SuggestionSchema } from '../../../common';
import { FallEmergence } from '../../../enums';

export const FallProtocolFormSchema = yup.object({
  fallDate: yup
    .date()
    .required()
    .default(() => new Date()),
  informDoctorDate: yup.lazy((value) => (value === null ? yup.string().nullable() : yup.date())),
  doctor: yup.string(),
  informRelativesDate: yup.lazy((value) => (value === null ? yup.string().nullable() : yup.date())),
  fallLocation: yup.string(),
  factilityNotResponsible: yup.boolean(),
  emergence: yup.lazy((value) =>
    value === null
      ? yup.string().nullable()
      : yup.mixed<FallEmergence>().oneOf(Object.values(FallEmergence)),
  ),
  emergenceGettingUp: yup.boolean().default(false),
  emergenceStanding: yup.boolean().default(false),
  emergenceWalking: yup.boolean().default(false),
  emergenceTransport: yup.boolean().default(false),
  emergenceToilet: yup.boolean().default(false),
  emergenceRecurrent: yup.boolean().default(false),
  emergenceAfterHospital: yup.boolean().default(false),
  emergenceOutsideInfluence: yup.boolean().default(false),
  fallCauseIntrinsic: yup.string(),
  fallCauseExtrinsic: yup.string(),
  fallDescription: yup.string(),
  fallConsequences: yup.boolean().required('Angabe erforderlich'),
  pain: yup.mixed().when('fallConsequences', {
    is: false,
    then: yup.mixed().default({}),
    otherwise: CheckboxTextSchema,
  }),
  laceration: yup.mixed().when('fallConsequences', {
    is: false,
    then: yup.mixed().default({}),
    otherwise: CheckboxTextSchema,
  }),
  abrasion: yup.mixed().when('fallConsequences', {
    is: false,
    then: yup.mixed().default({}),
    otherwise: CheckboxTextSchema,
  }),
  bounceMark: yup.mixed().when('fallConsequences', {
    is: false,
    then: yup.mixed().default({}),
    otherwise: CheckboxTextSchema,
  }),
  fracture: yup.mixed().when('fallConsequences', {
    is: false,
    then: yup.mixed().default({}),
    otherwise: CheckboxTextSchema,
  }),
  consultedDoctor: yup.boolean().required('Angabe erforderlich'),
  increasedSupportEveryday: yup.boolean().required('Angabe erforderlich'),
  increasedSupportMobility: yup.boolean().required('Angabe erforderlich'),
  measures: yup.string(),
});

export const FallProtocolCreateFormSchema = yup
  .object({
    resident: yup.string().required(),
  })
  .concat(FallProtocolFormSchema);

export const FallProtocolUpdateFormSchema = yup
  .object({
    id: yup.string().required(),
    fallId: yup.string().required(),
    resident: yup.string().optional().nullable(),
  })
  .concat(FallProtocolFormSchema);

export type IFallProtocolForm = yup.InferType<typeof FallProtocolFormSchema>;

export type IFallProtocolCreateForm = yup.InferType<typeof FallProtocolCreateFormSchema>;

export type IFallProtocolUpdateForm = yup.InferType<typeof FallProtocolUpdateFormSchema>;

export const FallProtocolSuggestionSchema = yup.object({
  fallLocation: SuggestionSchema.nullable(),
  fallCauseIntrinsic: SuggestionSchema.nullable(),
  fallCauseExtrinsic: SuggestionSchema.nullable(),
  fallConsequences: SuggestionSchema.nullable(),
});

export type IFallProtocolSuggestion = yup.InferType<typeof FallProtocolSuggestionSchema>;
